/* @flow */
import React, { useContext } from "react";
import MountOnBody from "nx-components/MountOnBody";
import connect from "nexia_mobile/flux_like/store/connect";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import SpinnerOverlay from "nexia_mobile/components/SpinnerOverlay";
import BuildingDashboardPage from "nexia_mobile/components/Pages/BuildingDashboardPage";
import DashboardPage from "nexia_mobile/components/Pages/DashboardPage";
import AppState from "nexia_mobile/models/app_state";
import Session from "nexia_mobile/models/session";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  appState: AppState,
  session?: Session,
  showDeviceAdd: () => void,
};

const HomePage = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language = languageContext.localeSet.nexia_mobile.pages.HomePage;
  const { appState, session, showDeviceAdd } = props;

  return (
    <BackboneListener listenTo={session} events={["change:locations"]}>
      {() => (
        <BackboneListener
          listenTo={appState}
          events={["change:currentLocation"]}
        >
          {() => {
            if (
              !appState.currentLocation &&
              session.get("locations") &&
              session.get("locations").length > 0
            ) {
              return (
                <BuildingDashboardPage
                  session={session}
                  showDeviceAdd={showDeviceAdd}
                />
              );
            } else if (
              appState.currentLocation &&
              session.get("locations") &&
              session.get("locations").length > 0
            ) {
              return (
                <DashboardPage
                  locations={session.get("locations")}
                  currentLocation={appState.currentLocation}
                  showDeviceAdd={showDeviceAdd}
                />
              );
            } else {
              return (
                <MountOnBody>
                  <SpinnerOverlay message={language.loadingBuilding} />
                </MountOnBody>
              );
            }
          }}
        </BackboneListener>
      )}
    </BackboneListener>
  );
};

export default connect(
  {
    appState: "appState",
    session: "session",
  },
  HomePage
);



// WEBPACK FOOTER //
// ./src/components/Pages/HomePage.jsx